<p-tabs
  [value]="selectedTabIndex"
  (valueChange)="selectedTabIndex = +$event.toString()"
>
  <p-tablist>
    <p-tab [value]="0">Manual</p-tab>
    <p-tab [value]="1">LLM</p-tab>
    <p-tab [value]="2">Processed</p-tab>
    <p-tab [value]="3">Discard</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <app-manual
        *ngIf="selectedTabIndex == 0"
        [filingIdInput]="filingId"
      ></app-manual>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <app-llm
        *ngIf="selectedTabIndex == 1"
        [filingIdInput]="filingId"
        [filingStateInput]="filingState"
      ></app-llm>
    </p-tabpanel>
    <p-tabpanel [value]="2">
      <app-processed
        *ngIf="selectedTabIndex == 2"
        [filingIdInput]="filingId"
          [filingStateInput]="filingState"
      ></app-processed>
    </p-tabpanel>
    <p-tabpanel [value]="3">
      <app-discard *ngIf="selectedTabIndex == 3"></app-discard>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
